module.exports = __webpack_public_path__ + "img/2.e40b3d2a.jpg";